// Utils and Constants
import {
  downloadFile,
  sendCreateOrUpdateRequest,
  sendGetRequest,
} from "../utils/api/apiUtils";
import { getToken } from "../utils/token";
import { DefaultPagination } from "../constants/GeneralConstants";

// Urls
import {
  cancelSiteMonitoringUrl,
  createSetupMonitoringSettingsUrl,
  downloadMonitoringExcelReportUrl,
  editMonitoringSettingsUrl,
  getMonitoringCampaignSummaryUrl,
  getMonitoringSettingByMediaUrl,
  getMonitoringSummaryByCityUrl,
} from "./../urls/MonitoringSettingsURL";

export async function getMonitoringCampSummaryData(id) {
  const headerParams = {
    "Content-Type": "application/json",
  };

  const url = getMonitoringCampaignSummaryUrl.replace(":campaignId", id);
  return sendGetRequest(url, {}, true, headerParams);
}

export async function getMonitoringSummaryByCity(
  campaignId,
  cityId,
  pageNumber,
  pageSizeCount,
  keyword,
  types
) {
  const headerParams = {
    "Content-Type": "application/json",
  };

  const params = {
    pn: pageNumber,
    ps: pageSizeCount || DefaultPagination.pageSize,
  };

  if (keyword) {
    params.kw = keyword;
  }
  if (types) {
    params._type = types;
  }

  const url = getMonitoringSummaryByCityUrl
    .replace(":campaignId", campaignId)
    .replace(":cityId", cityId);
  return sendGetRequest(url, params, true, headerParams);
}

export async function downloadMonitoringExcelReportFn(campaignId) {
  const headerParams = {
    Authorization: "Bearer " + getToken(),
  };

  return downloadFile(
    downloadMonitoringExcelReportUrl.replace(":campaignId", campaignId),
    true,
    headerParams
  );
}

export async function getMonitoringSettingsByMedia(campaignId, mediaId) {
  const headerParams = {
    "Content-Type": "application/json",
  };

  const url = getMonitoringSettingByMediaUrl
    .replace(":campaignId", campaignId)
    .replace(":mediaId", mediaId);
  return sendGetRequest(url, {}, true, headerParams);
}

export async function createSetupMonitoringSettings(
  inputFieldBean,
  campaignId
) {
  // Request Headers
  const headerParams = {
    "Content-Type": "application/json",
  };

  return sendCreateOrUpdateRequest(
    createSetupMonitoringSettingsUrl.replace(":campaignId", campaignId),
    inputFieldBean,
    true,
    "PUT",
    headerParams
  );
}

export async function cancelSiteMonitoringFn(monSettingIds) {
  // Request Headers
  const headerParams = {
    "Content-Type": "application/json",
  };

  return sendCreateOrUpdateRequest(
    cancelSiteMonitoringUrl,
    monSettingIds,
    true,
    "PUT",
    headerParams
  );
}

export async function editSiteMonitoringSettings(inputFieldBean, campaignId) {
  // Request Headers
  const headerParams = {
    "Content-Type": "application/json",
  };

  return sendCreateOrUpdateRequest(
    editMonitoringSettingsUrl.replace(":campaignId", campaignId),
    inputFieldBean,
    true,
    "PUT",
    headerParams
  );
}
